import { useState } from "react";
import PropTypes from "prop-types";
// @mui
import { Menu, Button, MenuItem, Typography } from "@mui/material";
// component
import Iconify from "../../../components/iconify";

// ----------------------------------------------------------------------

const SORT_BY_OPTIONS = [
  { value: "newest", label: "Datum (jüngeste zuerst)" },
  { value: "oldest", label: "Datum (älteste zuerst)" },
  { value: "userAZ", label: "Verantwortlicher(A-Z)" },
  { value: "userZA", label: "Verantwortlicher(Z-A)" },
  { value: "areaAZ", label: "Bereich(A-Z)" },
  { value: "areaZA", label: "Bereich(Z-A)" },
];

TaskSort.propTypes = {
  handleSortChange: PropTypes.func.isRequired,
};

// ----------------------------------------------------------------------

export default function TaskSort({ handleSortChange }) {
  const [open, setOpen] = useState(null);
  const [selectedOption, setSelectedOption] = useState("newest");

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    handleClose();
    handleSortChange(option);
  };

  return (
    <>
      <Button
        color="inherit"
        disableRipple
        onClick={handleOpen}
        endIcon={
          <Iconify
            icon={open ? "eva:chevron-up-fill" : "eva:chevron-down-fill"}
          />
        }
      >
        Sortierung:&nbsp;
        <Typography
          component="span"
          variant="subtitle2"
          sx={{ color: "text.secondary" }}
        >
          {
            SORT_BY_OPTIONS.find((option) => option.value === selectedOption)
              .label
          }
        </Typography>
      </Button>
      <Menu
        keepMounted
        anchorEl={open}
        open={Boolean(open)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {SORT_BY_OPTIONS.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === selectedOption}
            onClick={() => handleOptionSelect(option.value)}
            sx={{ typography: "body2" }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
